let _loadingPromise = null

export function loadTiandituJsApi({ tk, v = '4.0' } = {}) {
  if (typeof window === 'undefined') return Promise.reject(new Error('not_in_browser'))
  if (window.T && window.T.Map) return Promise.resolve(window.T)

  const safeTk = (tk || process.env.VUE_APP_TIANDITU_TK || '').trim()
  if (!safeTk) return Promise.reject(new Error('missing_tk'))

  if (_loadingPromise) return _loadingPromise

  _loadingPromise = new Promise((resolve, reject) => {
    const id = 'tianditu-js-api'
    const existing = document.getElementById(id)
    if (existing) {
      existing.addEventListener('load', () => resolve(window.T))
      existing.addEventListener('error', () => reject(new Error('script_load_failed')))
      return
    }

    const script = document.createElement('script')
    script.id = id
    script.async = true
    script.src = `https://api.tianditu.gov.cn/api?v=${encodeURIComponent(v)}&tk=${encodeURIComponent(safeTk)}`
    script.onload = () => {
      if (window.T && window.T.Map) resolve(window.T)
      else reject(new Error('tianditu_T_missing_after_load'))
    }
    script.onerror = () => reject(new Error('script_load_failed'))
    document.head.appendChild(script)
  })

  return _loadingPromise
}

